import { render } from "./SellerOrderDetails.vue?vue&type=template&id=66df6aa7&scoped=true"
import script from "./SellerOrderDetails.vue?vue&type=script&lang=js"
export * from "./SellerOrderDetails.vue?vue&type=script&lang=js"

import "./SellerOrderDetails.vue?vue&type=style&index=0&id=66df6aa7&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66df6aa7"]])

export default __exports__